var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveclassPlay = function SvgLiveclassPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#liveclass-play_svg__a)",
    clipRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.5a13.5 13.5 0 1 0 0-27 13.5 13.5 0 0 0 0 27m0 1.5a15 15 0 1 0 0-30 15 15 0 0 0 0 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.05 14.999c0 7.76-6.29 14.05-14.05 14.05-7.759 0-14.049-6.29-14.049-14.05S7.241.949 15.001.949 29.05 7.24 29.05 15M12 10.4 18.898 15 12 19.597zm8.635 4.103a1.05 1.05 0 0 0-.344-.378l-8.159-5.44a1.05 1.05 0 0 0-1.632.874v10.88a1.05 1.05 0 0 0 1.632.874l8.16-5.44a1.05 1.05 0 0 0 .343-1.37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "liveclass-play_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgLiveclassPlay;